export const state = {
  appWidth: window.innerWidth,
};

export const getters = {
  getAppSize: (state) => {
    let size = 'xl';

    if (state.appWidth < 768) {
      size = 'sm';
    } else if (state.appWidth < 1018) {
      size = 'md';
    } else if (state.appWidth < 1248) {
      size = 'lg';
    }
    return size;
  },
  appIsLarge: (state, getters) => ['xl', 'lg'].includes(getters.getAppSize),
  appIsSmall: (state, getters) => ['sm', 'md'].includes(getters.getAppSize),
  appIsExtraLarge: (state, getters) => getters.getAppSize === 'xl',
  appIsMobile: (state, getters) => getters.getAppSize === 'sm',
  appIsTablet: (state, getters) => getters.getAppSize === 'md',
};

export const mutations = {
  SET_APP_WIDTH(state, newValue) {
    state.appWidth = newValue;
  },
};
